import React from "react";
import PageHeader from "../../components/common/PageHeader";
import PageMeta from "../../components/common/PageMeta";
import FeatureImgContentThree from "../../components/feature-img-content/FeatureImgContentThree";
import FeatureImgEight from "../../components/features/FeatureImgEight";
import IA from "../../components/features/ia";
import RequestForDemo from "../../components/others/RequestForDemo";
import PromoThree from "../../components/promo/PromoThree";
import FooterOne from "../../layout/Footer/FooterOne";

import Navbar from "../../layout/Header/Navbar";
import Layout from "../../layout/Layout";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";

const serviceTypeMap = {
  'recrutamento-tech': 'professionals.recruitment',
  'rightee': 'professionals.rightee',
  'cardiohome': 'professionals.cardiohome',
  'grupovisco': 'professionals.grupovisco',
  'carreiras': 'professionals.careers',
  'outsourcing': 'professionals.outsourcing',
  'sistemas-plataformas': 'software.systems',
  'aplicativos': 'software.apps',
  'migracao-cloud': 'infrastructure.migration',
  'gerenciar-otimizar': 'infrastructure.management',
  'ia-generativa': 'ai.generative',
  'ia-personalizada': 'ai.custom'
};

const ServiceType = () => {
  let { type } = useParams();
  const { t } = useLanguage();

  type = type || "carreiras";

  const serviceKey = serviceTypeMap[type];

  type = type || "carreiras";

  console.log(serviceKey);


  if (!serviceKey) {
    return (
      <Layout>
        <PageMeta title="Serviço não encontrado" />
        <Navbar classOption="navbar-light" />
        <PageHeader title="Serviço não encontrado" desc="O tipo de serviço informado não existe." />
        <FooterOne footerLight />
      </Layout>
    );
  }

  const conteudo = {
    title: t(`features.featureFive.categories.${serviceKey}.title`),
    desc: t(`features.featureFive.categories.${serviceKey}.desc`),
    features: {
      title: t(`features.featureFive.categories.${serviceKey}.features.title`),
      description: t(`features.featureFive.categories.${serviceKey}.features.description`),
      items: t(`features.featureFive.categories.${serviceKey}.features.items`),
      image: t(`features.featureFive.categories.${serviceKey}.features.image`)
    },
    analytics: {
      title: t(`features.featureFive.categories.${serviceKey}.analytics.title`),
      description: t(`features.featureFive.categories.${serviceKey}.analytics.description`),
      items: t(`features.featureFive.categories.${serviceKey}.analytics.items`), 
      image: t(`features.featureFive.categories.${serviceKey}.analytics.image`)
    }
  };

  

  console.log(conteudo);

  return (
    <Layout>
      <PageMeta title={conteudo.title} />
      <Navbar classOption="navbar-light" />
      <PageHeader title={conteudo.title} desc={conteudo.desc} />


      {type === 'ia-generativa' || type === 'ia-personalizada' ? (
        <IA />
      ) : (
        <>
          <FeatureImgEight 
            title={conteudo.features?.title}
            description={conteudo.features?.description}
            items={conteudo.features?.items}
            image={conteudo.features?.image}

          />
          <FeatureImgContentThree 
            title={conteudo.analytics?.title}
            description={conteudo.analytics?.description}
            items={conteudo.analytics?.items}
            image={conteudo.analytics?.image}
          />
          <PromoThree hasBg />
          
        </>
      )}

      <RequestForDemo  />


      
      <FooterOne footerLight />
    </Layout>
  );
};

export default ServiceType; 